import { rootApi } from '../rootApi';

export const vehicleSaleReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleSaleReport: builder.query({
            query: (body) => ({
                url: 'v1/VehicleSaleReport/GetList',
                method: 'POST',
                body: {
                    pageSize: body?.pageSize ?? 10,
                    pageNumber: body?.pageNumber ?? 1,
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    includeFilterOptions: body?.includeFilterOptions ?? false,
                    filterOptionsColumns: body?.filterOptionsColumns ?? null,
                    languageId: body?.languageId,
                    dealerBranchCode: body?.dealerBranchCode ?? null
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['VehicleSaleReport']
        }),
        exportVehicleSaleReportToExcel: builder.query({
            query: (body) => ({
                url: 'v1/VehicleSaleReport/ExportToExcel',
                method: 'POST',
                body: {
                    languageId: body?.languageId,
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    dealerBranchCode: body?.dealerBranchCode ?? null,
                    compressionType: body?.compressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export başarısız oldu');
            }
        })
    }),
    overrideExisting: false
});

export const { useGetVehicleSaleReportQuery, useLazyExportVehicleSaleReportToExcelQuery } = vehicleSaleReportApi;
